// extracted by mini-css-extract-plugin
module.exports = {"link":"content-section_link__Fx7fa","linkActive":"content-section_linkActive__q2Ten"};